import { Text } from "@/components/ui"
import { useEffect, useRef } from "react"
import { PrizeGameButton, PrizeGameLink } from "./PrizeGameButton"

type PrizeLoginPromptProps = {
  game: "wheel" | "scratch"
  onSignIn: () => void
  onDismiss: () => void
}

/** The gentle ask shown under an anonymous visitor's ticket or wheel, worded for the game: focused and announced as a dialog; "Entrar" opens the inline sign-in, "Agora não" just puts it away. */
export function PrizeLoginPrompt({ game, onSignIn, onDismiss }: PrizeLoginPromptProps) {
  const root = useRef<HTMLDivElement>(null)
  useEffect(() => root.current?.focus({ preventScroll: true }), [])
  return (
    <div
      role="dialog"
      aria-label="Entrar na sua conta"
      tabIndex={-1}
      ref={root}
      className="flex flex-col items-stretch gap-2 outline-none"
    >
      <Text size="sm" weight="bold" tone="default" balance>
        Entre na sua conta para {game === "wheel" ? "girar a roleta" : "raspar o cartão"} e ganhar o prêmio
      </Text>
      <PrizeGameButton className="rounded-game-button" onClick={onSignIn}>
        Entrar
      </PrizeGameButton>
      <PrizeGameLink onClick={onDismiss}>Agora não</PrizeGameLink>
    </div>
  )
}
